import { AnalysisMarkdown } from './AnalysisMarkdown';
import { AnalysisSubHeader } from './AnalysisSubHeader';
import { NumberedCard } from './NumberedCard';

export interface NumberedListItem {
  /** Body text; rendered as markdown. */
  text: string;
  /** Optional heading shown under the number badge. */
  label?: string;
}

interface NumberedListProps {
  title: string;
  subtitle?: string;
  items: NumberedListItem[];
}

/**
 * A numbered set of bordered cards in a three-column grid (Audience Profiles' sub-cultures
 * and adjacent audiences, Marketing Performance's insights).
 *
 * The number leads each card, with the label beneath it rather than beside: the design
 * stacks them so a long label does not push the badge off its own line.
 */
export const NumberedList = ({ title, subtitle, items }: NumberedListProps) => {
  if (!items.length) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader title={title} subtitle={subtitle} subtitleTone="meta" />

      <div className="grid grid-cols-1 items-stretch gap-sm sm:grid-cols-2 md:grid-cols-3">
        {items.map((item, index) => (
          <NumberedCard
            key={`${item.label ?? item.text}-${index}`}
            position={index + 1}
            label={item.label}
          >
            <AnalysisMarkdown text={item.text} className="text-body-md text-foreground-alt" />
          </NumberedCard>
        ))}
      </div>
    </div>
  );
};
